var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportsActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H17V8H3V3H1C0.447 3 0 3.447 0 4V23C0 23.553 0.447 24 1 24H19C19.553 24 20 23.553 20 23V4C20 3.447 19.553 3 19 3ZM16 19H4V17H16V19ZM16 14H4V12H16V14Z",
    fill: "#001350"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C12 0.895 11.105 0 10 0C8.895 0 8 0.895 8 2H5V6H15V2H12Z",
    fill: "#4F8CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsActive);
export default __webpack_public_path__ + "static/media/reports-active.d906a475466fd0989d7c75702dcec80e.svg";
export { ForwardRef as ReactComponent };